import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45569f6e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45569f6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45569f6e')) {
      api.createRecord('45569f6e', component.options)
    } else {
      api.reload('45569f6e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=45569f6e&scoped=true", function () {
      api.rerender('45569f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/preSale-management/preSale-wait-pay/index.vue"
export default component.exports